var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgString = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#696E7B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14 2.667H2a.667.667 0 0 0-.667.666v9.334c0 .368.299.666.667.666h12a.667.667 0 0 0 .667-.667V3.333A.667.667 0 0 0 14 2.666ZM10.666 8.334v2.333M8 5.333v5.334M5.333 6.667v4"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgString);
export default ForwardRef;